import {
  BookedWorkCell,
  type LedgerCollapse,
  type LedgerColumn,
} from '@billda/design-system';

/**
 * Activity's single collapse point. Below it every column hides and each row
 * grows a meta line carrying what they held, so there is no separate narrow
 * row component any more.
 */
export const ACTIVITY_COLLAPSE: LedgerCollapse = {
  container: 'activity-ledger',
  at: 760,
};

/** Site names truncate in the Site / Plot cell; the plot number never does. */
export const ACTIVITY_COLUMNS: LedgerColumn[] = [
  { key: BookedWorkCell.Ref, label: 'Ref', flex: 0.8 },
  { key: BookedWorkCell.SitePlot, label: 'Site / Plot', flex: 1.9 },
  { key: BookedWorkCell.BookedBy, label: 'Booked by', flex: 1.1 },
  { key: BookedWorkCell.When, label: 'When', flex: 1 },
];
